<template>
  <div>
    <!--기본정보-->
    <field-select-module v-model="form.stdInfo" :board="this.board" :is-print="isPrint" @selectField="changeField" />

    <!-- 사용개소 -->
    <div class="mt-28px">
      <h5 class="mb-4"><i class="dot"></i> 사용개소</h5>

      <div class="writeGridContainer">
        <div>
          <div>공장명</div>
          <p v-if="isPrint" class="print-input">{{ form.공장명 }}</p>
          <CustomOptionSelector v-else class="flex-1 w-full" :options="공장명options" :readonly="board.readonly || form.stdInfo.field_id === 0" @input="changeOptions" v-model="form.공장명" @click.native.stop="onFactoryClick" />
        </div>
        <div>
          <div>공정명</div>
          <p v-if="isPrint" class="print-input">{{ form.공정명 }}</p>
          <CustomOptionSelector v-else class="flex-1 w-full" :options="공정명options" :readonly="board.readonly || form.stdInfo.field_id === 0 || form.공장명 === ''" v-model="form.공정명" />
        </div>
      </div>
    </div>

    <!-- 제품정보 -->
    <div class="mt-28px">
      <h5 class="mb-4"><i class="dot"></i> 제품정보</h5>

      <div class="writeGridContainer">
        <div class="writeGridCol2">
          <div>제품명(물질명)</div>
          <p v-if="isPrint" class="print-input">{{ form.제품명 }}</p>
          <ml-input v-else v-model="form.제품명" />
        </div>
        <div>
          <div>MSDS 등록번호</div>
          <p v-if="isPrint" class="print-input">{{ form.msds등록번호 }}</p>
          <ml-input v-else v-model="form.msds등록번호" />
        </div>
      </div>
      <div class="writeGridContainer">
        <div>
          <div>제조사(공급사)</div>
          <p v-if="isPrint" class="print-input">{{ form.제조사 }}</p>
          <ml-input v-else v-model="form.제조사" />
        </div>
        <div>
          <div>용도</div>
          <p v-if="isPrint" class="print-input">{{ form.용도 }}</p>
          <ml-input v-else v-model="form.용도" />
        </div>
      </div>
    </div>

    <!-- 물질안전보건자료 목록 -->
    <MSDSTable title="구성성분 정보" :isReadonly="board.readonly" :isPrint="isPrint" v-model="form.구성성분" class="mt-28px" />

    <!-- 관련 파일첨부 -->
    <div class="mt-28px">
      <h5 class="mb-4"><i class="dot"></i> 관련 파일첨부</h5>

      <div class="writeGridContainer">
        <div>
          <div>MSDS</div>
          <p v-if="isPrint" class="print-input">{{ form.MSDS && form.MSDS.fileName ? form.MSDS.fileName : "" }}</p>
          <file-uploader v-else :readonly="board.readonly" v-model="form.MSDS" />
        </div>
        <div>
          <div>경고표지</div>
          <p v-if="isPrint" class="print-input">{{ form.경고표지 && form.경고표지.fileName ? form.경고표지.fileName : "" }}</p>
          <file-uploader v-else :readonly="board.readonly" v-model="form.경고표지" />
        </div>
        <div>
          <div>교육날인부</div>
          <p v-if="isPrint" class="print-input">{{ form.교육날인부 && form.교육날인부.fileName ? form.교육날인부.fileName : "" }}</p>
          <file-uploader v-else :readonly="board.readonly" v-model="form.교육날인부" />
        </div>
      </div>
    </div>

    <file-upload-module title="파일첨부" :readonly="board.readonly" v-model="form.fileList" :is-print="isPrint" class="mt-28px" />

    <popup-load-prev-board v-model="showLoadPrevBoard" :set-board-id="1030" @selectRowData="prevBoardSelectRow" />
  </div>
</template>

<script>
import DateSelector from "@/components/selector/DateSelector";
import FileUploadModule from "@/views/modules/FileUploadModule";
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import WriteGridContainer from "@/components/WriteGridContainer.vue";
import CustomOptionSelector from "@/components/selector/CustomOptionSelector.vue";
import PhotoUploadGridModule from "@/views/modules/PhotoUploadGridModule.vue";
import NameWithSignatureRow from "@/components/NameWithSignatureRow.vue";
import MSDSTable from "./MSDSTable.vue";

import { 당진공장, 인천공장, 포항공장 } from "./options";
import FileUploader from "@/components/FileUploader.vue";
import PopupLoadPrevBoard from "@/popup/PopupLoadPrevBoard.vue";

export default {
  components: {
    PopupLoadPrevBoard,
    FileUploader,
    MSDSTable,
    NameWithSignatureRow,
    PhotoUploadGridModule,
    CustomOptionSelector,
    WriteGridContainer,
    DateSelector,
    FileUploadModule,
    FieldSelectModule,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  watch: {
    value: {
      important: true,
      deep: true,
      handler(value) {
        if (value) {
          const keys = Object.keys(value);
          for (const key of keys) {
            if (value[key]) {
              this.form[key] = value[key];
            }
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
  },
  computed: {
    projectId() {
      return parseInt(this.$route.params.proj_id);
    },
    공장명options() {
      if (!this.form.stdInfo.field_name) return [];
      const 공장별목록 = {
        당진공장: Object.keys(당진공장),
        인천공장: Object.keys(인천공장),
        포항공장: Object.keys(포항공장),
      };
      return 공장별목록[this.form.stdInfo.field_name] || [];
    },
    공정명options() {
      if (!this.form.공장명) return [];
      const 공정목록 = {
        당진공장,
        인천공장,
        포항공장,
      };
      return 공정목록[this.form.stdInfo.field_name][this.form.공장명] || [];
    },
  },
  data() {
    return {
      showLoadPrevBoard: false,
      isFactoryClick: false,
      form: {
        stdInfo: {},

        공장명: "",
        공정명: "",

        제품명: "",
        msds등록번호: "",
        제조사: "",
        용도: "",

        구성성분: [],
        MSDS: {},
        경고표지: {},
        교육날인부: {},

        fileList: [],
      },
    };
  },
  methods: {
    changeField() {
      this.form.공장명 = "";
      this.form.공정명 = "";
    },
    onFactoryClick() {
      this.isFactoryClick = true;
    },
    changeOptions() {
      if (this.isFactoryClick) this.form.공정명 = "";
    },
    setNormalBoardButtons(template) {
      const 이전문서불러오기 = {
        shouldShow: { mode: "c|u", freePass: 0, permission: "c|u", onlyWriter: true},
        component: "vs-button",
        props: { class: "col-span-2", color: "secondary", type: "border" },
        content: "MSDS 관리 불러오기",
        emits: {
          click: (func) => {
            this.showLoadPrevBoard = true;
          },
        },
      }
      return [ 이전문서불러오기, template.print, template.delete, template.move, template.save ]
    },
    prevBoardSelectRow(data) {
      let postContent = data.post_content;
      if (postContent) {
        postContent = JSON.parse(postContent);
        const body = postContent.body;

        this.form = body
      }
    },
  },
};
</script>
